import { cx } from "@emotion/css";
import { Filter } from "lucide-react";
import { Menu } from "src/components/Default/LekUI/Menu";

export interface FilterOption<T> {
	value: T;
	label: string;
	testId?: string;
}

interface FiltersProps<T> {
	options: FilterOption<T>[];
	value: T;
	onChange: (value: T) => void;
	defaultValue?: T;
	anchorId?: string;
	buttonTestId?: string;
}

export function Filters<T>({
	options,
	value,
	onChange,
	defaultValue,
	anchorId,
	buttonTestId,
}: FiltersProps<T>) {
	const isActive = value !== defaultValue;
	const selectedLabel = options.find((opt) => opt.value === value)?.label;

	return (
		<Menu
			anchorId={anchorId}
			buttonTestId={buttonTestId}
			closeAfterClick
			icon={
				<span className="flex items-center gap-8">
					{selectedLabel && (
						<span className={cx("size-14-light", { "text-primary": isActive })}>
							{selectedLabel}
						</span>
					)}
					<Filter className={cx("icon-small", { "icon-primary": isActive })} />
				</span>
			}
			items={options.map((opt) => ({
				title: opt.label,
				onClick: () => onChange(opt.value),
				selected: opt.value === value,
				testId: opt.testId,
			}))}
		/>
	);
}
